export default[
		{
		    path: '/classlistarr',
		    name: 'classlistarr',
	    	component: () => import('@/views/coursefolder/classlistarr.vue')
		},
		{
		    path: '/detailsclass',
		    name: 'detailsclass',
	    	component: () => import('@/views/coursefolder/detailsclass.vue')
		},
		
]
